import { apiClient } from './client';
import type { Brand, Category, CustomerGroup, StoreInfo } from './types';

export const storeApi = {
  async getInfo(): Promise<StoreInfo> {
    return apiClient.request<StoreInfo>('/store/info');
  },

  async getCategories(): Promise<{ categories: Category[]; total: number }> {
    return apiClient.request<{ categories: Category[]; total: number }>('/store/categories');
  },

  async getBrands(): Promise<{ brands: Brand[]; total: number }> {
    return apiClient.request<{ brands: Brand[]; total: number }>('/store/brands');
  },

  async getCustomerGroups(): Promise<{ groups: CustomerGroup[]; total: number }> {
    return apiClient.request<{ groups: CustomerGroup[]; total: number }>('/store/customer-groups');
  },
};
